/* eslint-disable no-bitwise */
/* eslint-disable no-unused-vars */

const allNews = () => {





  function less() {
		//	alert('less');
  const loadMoreBtns2 = document.querySelectorAll('.js-load-less-btn');
  loadMoreBtns2.forEach(btn => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();

      let section = btn.closest('.js-all-news-section');
      let ajaxData = {
        action: 'load_less_news',
        ks_post_type: section.dataset.type,
        ks_already_showed: 3,
        ks_total_posts: section.dataset.totalPosts,
      };

      let ajaxParameters = Object.entries(ajaxData)
        .map(e => e.join('='))
        .join('&');

      /**
       * Ajax post
       */
      const ajax_url = document.querySelector('meta[name="ajax_url"]').content;
      let request = new XMLHttpRequest();
      request.open('POST', ajax_url, true);
      request.setRequestHeader(
        'Content-Type',
        'application/x-www-form-urlencoded;',
      );
      request.onload = function () {
        let results = JSON.parse(this.response);
        document.querySelector(`.js-all-news-section[data-type="${results.ks_post_type}"]`).outerHTML = results.ks_html;
		more();
      };
      request.onerror = function () {
        console.log(ajaxData);
        console.error(this.response);
      };
      request.send(ajaxParameters);

    });


});

}



function more() {
			

  const loadMoreBtns = document.querySelectorAll('.js-load-more-btn');
  loadMoreBtns.forEach(btn => {

    btn.addEventListener('click', (e) => {
      e.preventDefault();

	      let section = btn.closest('.js-all-news-section');


	    let ajaxData = {
        action: 'load_more_news',
        ks_post_type: section.dataset.type,
        ks_already_showed: section.dataset.alreadyShowed,
        ks_total_posts: section.dataset.totalPosts,
      };

      let ajaxParameters = Object.entries(ajaxData)
        .map(e => e.join('='))
        .join('&');




      /**
       * Ajax post
       */
      const ajax_url = document.querySelector('meta[name="ajax_url"]').content;
      let request = new XMLHttpRequest();
      request.open('POST', ajax_url, true);
      request.setRequestHeader(
        'Content-Type',
        'application/x-www-form-urlencoded;',
      );
      request.onload = function () {
        let results = JSON.parse(this.response);
        document.querySelector(`.js-all-news-section[data-type="${results.ks_post_type}"]`).outerHTML = results.ks_html;
    		less();

 

      };
      request.onerror = function () {
        console.log(ajaxData);
        console.error(this.response);
      };
      request.send(ajaxParameters);

	

    });

 

  });

}


window.onload = function() {
more();
};






};

export default allNews;


// WEBPACK FOOTER //
// ./wp/wp-content/themes/eco-chisel/src/scripts/modules/allNews.js